import { isNil } from 'lodash'

import { ROUTE_PATHS } from '@/routes/route-helpers'
import { removeUnnecessarySlashes } from '@/utils/external-link-helper'
import { isStringEmpty } from '@/utils/general'

const DEFAULT_WEB_APP_LOGIN_URL = 'https://id.oboard.io'

const createLoginAppRoute = (...routeSegments) => {
  return routeSegments.map(removeUnnecessarySlashes).join('/')
}

const pushToUrl = (url = DEFAULT_WEB_APP_LOGIN_URL) => {
  window.location.replace(url)
}

export const redirectToLogout = ({ webAppLoginUrl = DEFAULT_WEB_APP_LOGIN_URL } = {}) => {
  const url = createLoginAppRoute(
    webAppLoginUrl,
    ROUTE_PATHS.WEB_APP_ACCOUNT_LAYOUT,
    ROUTE_PATHS.WEB_APP_LOGOUT
  )

  pushToUrl(url)
}

export const redirectToSwitchOrganization = ({
  webAppLoginUrl = DEFAULT_WEB_APP_LOGIN_URL,
  organizationId = ''
} = {}) => {
  if (isStringEmpty(organizationId) || isNil(organizationId)) {
    throw new Error('Missing required parameter: organizationId')
  }
  const url = createLoginAppRoute(
    webAppLoginUrl,
    ROUTE_PATHS.WEB_APP_ACCOUNT_LAYOUT,
    ROUTE_PATHS.WEB_APP_SWITCH_ORGANIZATION,
    organizationId
  )

  pushToUrl(url)
}
